export const isAppleDevice = () => {
	return (
		['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod', 'MacIntel', 'Macintosh'].includes(navigator.platform) ||
		// iPad on iOS 13 detection
		(navigator.userAgent.includes('Mac') && Boolean(document.ontouchend))
	);
};

export const isMobileAppleDevice = () => {
	return ['iPhone Simulator', 'iPhone'].some((fragment) => navigator.userAgent.includes(fragment));
};

export const isSafari = () => navigator.userAgent.toLocaleLowerCase().includes('safari');

export const isTabletAppleDevice = () => {
	return (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0) || navigator.platform === 'iPad';
};
